import { create } from 'zustand'

import apiHandler from 'components/Defaults/ApiHandler'
import axios from 'axios'

export const getDocumentAvailabilityStatistics = (callback, errorCallback) => {
  const config = {
      url: '/api/admin/book_availability_stats',
      method: "GET"
  }
  apiHandler("Getting Stats", config, async config => {
      const response = await axios.request(config);
      callback && callback(response.data)
  }, errorCallback)
}

export const usetStatisticsStore = create((set, get) => ({
  statistics: null,
  loading: false,

  fetchStatistics: () => {
    if (get().statistics) return

    getDocumentAvailabilityStatistics(
      (data) => {
        set(() => ({ statistics: data, loading: false }))
      },
      (error) => {
        set(() => ({ loading: false }))
      }
    );
  }
}))

